import React from 'react';
import * as R from 'ramda';
import AppleIcon from '@mui/icons-material/Apple';
import {SocialAuthIntegration} from '@practicegenius/domain/src/data/integrations';
import {EmailIcon} from '@practicegenius/pg-ui/src/icons/EmailIcon';
import {ColoredGoogleLogo} from '@practicegenius/pg-ui/src/icons/social/ColoredGoogleLogo';
import {FacebookCircleLogo} from '@practicegenius/pg-ui/src/icons/social/FacebookCircleLogo';
import {SvgIconComponent} from '@practicegenius/pg-ui/src/icons/types';
import {Theme} from '@mui/material';

export const borderGray = '#B8B8B8';

export const facebookBlue = '#4464A2';
export const googleRed = '#DF4E3F';
export const microsoftTeal = '#04ADF1';
export const appleBlack = '#000000';
export const emailOrange = '#FFB932';
export const mcFuckinWhite = '#FFFFFF';
export const werewolfGray = 'rgba(0, 0, 0, 0.60)';
export const pecadilloGray = 'rgba(0, 0, 0, 0.04)';

type ButtonKey = SocialAuthIntegration | 'email';
type ButtonObject = Record<ButtonKey, (theme: Theme) => string>;

export const socialColors: ButtonObject = {
  facebook: R.always(mcFuckinWhite),
  google: R.always(mcFuckinWhite),
  apple: R.always(mcFuckinWhite),
  email: theme => theme.palette.primary.main,
};

export const socialColorsHover: ButtonObject = {
  facebook: R.always(pecadilloGray),
  google: R.always(pecadilloGray),
  apple: R.always(pecadilloGray),
  email: theme => theme.palette.primary.dark,
};

export const socialTextColors: ButtonObject = {
  facebook: R.always(werewolfGray),
  google: R.always(werewolfGray),
  apple: R.always(werewolfGray),
  email: R.always(mcFuckinWhite),
};

const grayBorder = `1px solid ${werewolfGray}`;
export const socialBorders: ButtonObject = {
  facebook: R.always(grayBorder),
  google: R.always(grayBorder),
  apple: R.always(grayBorder),
  email: R.always('none'),
};

export const socialButtonIcons: Record<ButtonKey, SvgIconComponent> = {
  apple: AppleIcon,
  facebook: props => <FacebookCircleLogo useBrandColor {...props} />,
  google: ColoredGoogleLogo,
  email: EmailIcon,
};
